import { CurrentProfileRole } from 'services/api';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';

export const useProfileRole = () => {
  const { profile, userRole, isProfileFetching } = useAppSelector(
    (state) => state.currentProfileState,
  );

  return {
    profile,
    userRole,
    isLoading: isProfileFetching,
    isAdmin: userRole === CurrentProfileRole.ADMIN,
    isManager: userRole === CurrentProfileRole.MANAGER,
    isUser: userRole === CurrentProfileRole.USER,
  };
};
